import { IUserApp } from '../../interfaces/models';
import { Action } from '@ngrx/store';

export const SET = '[Users] Set';
export const ADD = '[Users] Add';
export const EDIT = '[Users] Edit';
export const DELETE = '[Users] Delete';
export const OPEN_MODAL = '[Users] Open modal';
export const CLOSE_MODAL = '[Users] Close modal';

export class Set implements Action {
  readonly type = SET;

  constructor(public data: IUserApp[]) {}
}

export class Add implements Action {
  readonly type = ADD;

  constructor(public data: IUserApp) {}
}

export class Edit implements Action {
  readonly type = EDIT;

  constructor(public data: IUserApp) {}
}

export class Delete implements Action {
  readonly type = DELETE;

  constructor(public id: any) {}
}

export class OpenModal implements Action {
  readonly type = OPEN_MODAL;
}

export class CloseModal implements Action {
  readonly type = CLOSE_MODAL;
}

export type All = Set | Add | Edit | Delete | OpenModal | CloseModal;
